import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { query } from "lib/graphql/query"

export const getClientUserMeta = api(({ id }) =>
    query(
        gql`
            query GetClientUserMeta($id: ID!) {
                getClientUserMeta(id: $id) {
                    userName
                    displayName
                    jobTitle
                    skills
                    status
                    metadata
                    photoURL
                }
            }
        `,
        { id },
        { returns: "getClientUserMeta" }
    )
)

export const createClientUser = api(({ email, displayName, jobTitle, skills, status, roles = [], photoURL, client }) =>
    mutate(
        gql`
            mutation createClientUser(
                $email: String!
                $displayName: String!
                $jobTitle: String
                $skills: [String]
                $status: String
                $roles: [String]
                $photoURL: String
                $client: String
            ) {
                createClientUser(
                    email: $email
                    displayName: $displayName
                    jobTitle: $jobTitle
                    skills: $skills
                    status: $status
                    roles: $roles
                    photoURL: $photoURL
                    client: $client
                )
            }
        `,
        { email, displayName, jobTitle, skills, status, roles, photoURL, client },
        { returns: "createClientUser" }
    )
)

export const updateClientUserMeta = api(
    ({
        email: userName,

        metadata: { id, displayName, jobTitle, skills, status, roles = [] } = {},
        photoURL,
    }) =>
        mutate(
            gql`
                mutation updateClientUserMeta(
                    $id: String!
                    $userName: String!
                    $displayName: String!
                    $jobTitle: String
                    $skills: [String]
                    $status: String
                    $roles: [String]
                    $photoURL: String
                ) {
                    updateClientUserMeta(
                        id: $id
                        userName: $userName
                        displayName: $displayName
                        jobTitle: $jobTitle
                        skills: $skills
                        status: $status
                        roles: $roles
                        photoURL: $photoURL
                    )
                }
            `,
            { id, userName, displayName, jobTitle, skills, status, roles, photoURL },
            { returns: "updateClientUserMeta" }
        )
)

export const inviteClientUser = api(({ email }) =>
    mutate(
        gql`
            mutation inviteClientUser($email: String!) {
                inviteClientUser(email: $email)
            }
        `,
        { email },
        { returns: "inviteClientUser" }
    )
)
